<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-content">
        <div class="footer-section">
          <h3>联系我们</h3>
          <div class="contact-info">
            <p class="address">
              新加坡福清会馆<br>
              爱伦比路二号<br>
              新加坡邮区 209973
            </p>
            <p><strong>Tel:</strong> <a href="tel:+6562983222">+65 6298 3222</a></p>
            <p><strong>Fax:</strong> +65 6298 4888</p>
            <p><strong>Email:</strong> <a href="mailto:contact@fuqing.sg">contact@fuqing.sg</a></p>
            <p>
              <a
                href="https://www.google.com/maps/search/?api=1&query=2+Allenby+Road+Singapore+209973"
                target="_blank"
                rel="noopener noreferrer"
                class="map-link"
                aria-label="在 Google 地图上查看会馆位置"
              >
                查看地图
              </a>
            </p>
          </div>
        </div>

<!--        <div class="footer-section">-->
<!--          <h3>社交媒体</h3>-->
<!--          <p class="social-desc">关注我们的官方Facebook和YouTube<br>以获取最新消息！</p>-->
<!--          <div class="social-links">-->
<!--            <a href="#facebook" class="social-link">Facebook</a>-->
<!--            <a href="#youtube" class="social-link">YouTube</a>-->
<!--          </div>-->
<!--        </div>-->

        <div class="footer-section">
          <h3>快速链接</h3>
          <ul class="quick-links">
            <li><a href="#venue">场地租用</a></li>
            <li><a href="#poiching">培青学校</a></li>
            <li><a href="#news">最新消息</a></li>
            <li><a href="#join">加入我们</a></li>
            <li><a href="#faq">常见问题</a></li>
          </ul>
        </div>
      </div>

      <div class="footer-bottom">
        <p>版权 © 2026 新加坡福清会馆</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>

<style scoped>
.footer {
  background: #2c3e50;
  color: #ecf0f1;
  padding: 3rem 0 1.5rem;
  margin-top: 4rem;
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  margin-bottom: 2rem;
}

.footer-section h3 {
  color: white;
  margin-bottom: 1rem;
  font-size: 1.25rem;
}

.contact-info p {
  margin-bottom: 0.5rem;
  line-height: 1.8;
}

.contact-info .address {
  white-space: pre-line;
  margin-bottom: 1rem;
}

.contact-info a {
  color: var(--secondary-color);
  text-decoration: none;
}

.contact-info a:hover {
  text-decoration: underline;
}

.map-link {
  display: inline-block;
  margin-top: 0.5rem;
  color: var(--secondary-color);
  text-decoration: none;
  font-weight: 500;
}

.map-link:hover {
  text-decoration: underline;
}

.social-desc {
  margin-bottom: 1rem;
  white-space: pre-line;
  line-height: 1.6;
}

.social-links {
  display: flex;
  gap: 1rem;
}

.social-link {
  display: inline-block;
  padding: 0.5rem 1rem;
  background: var(--primary-color);
  color: white;
  text-decoration: none;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.social-link:hover {
  background: var(--primary-dark);
  transform: translateY(-2px);
}

.quick-links {
  list-style: none;
}

.quick-links li {
  margin-bottom: 0.5rem;
}

.quick-links a {
  color: #bdc3c7;
  text-decoration: none;
  transition: color 0.3s ease;
}

.quick-links a:hover {
  color: var(--secondary-color);
}

.footer-bottom {
  border-top: 1px solid #34495e;
  padding-top: 1.5rem;
  text-align: center;
  color: #95a5a6;
}

.privacy-link {
  color: var(--secondary-color);
  text-decoration: none;
  transition: color 0.3s ease;
}

.privacy-link:hover {
  color: white;
  text-decoration: underline;
}

@media (max-width: 768px) {
  .footer-content {
    grid-template-columns: 1fr;
  }
}
</style>

